var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommandsDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 438,
    height: 438,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 141,
    width: 438,
    height: 438
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-145 -141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.606 427.981 245.831 415.206 285.069 375.969 245.831 336.731 258.606 323.956 310.619 375.969Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.5 218.562 181.5 501.438 546.5 501.438 546.5 218.562 181.5 218.562ZM496.312 245.938C501.331 245.938 505.438 250.044 505.438 255.062 505.438 260.081 501.331 264.188 496.312 264.188 491.294 264.188 487.188 260.081 487.188 255.062 487.188 250.044 491.294 245.938 496.312 245.938ZM464.375 245.938C469.394 245.938 473.5 250.044 473.5 255.062 473.5 260.081 469.394 264.188 464.375 264.188 459.356 264.188 455.25 260.081 455.25 255.062 455.25 250.044 459.356 245.938 464.375 245.938ZM432.438 245.938C437.456 245.938 441.562 250.044 441.562 255.062 441.562 260.081 437.456 264.188 432.438 264.188 427.419 264.188 423.312 260.081 423.312 255.062 423.312 250.044 427.419 245.938 432.438 245.938ZM519.125 474.062 208.875 474.062 208.875 291.562 519.125 291.562 519.125 474.062Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.375 410.188 391.375 410.188 391.375 428.438 318.375 428.438Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommandsDark);
export default __webpack_public_path__ + "static/media/commands_dark.c023b53422801e9218aafbe29c8f5a01.svg";
export { ForwardRef as ReactComponent };